import React from 'lib/react';
import { EVGrid, EVPaper } from '@eagleview/ev-comp-library';
import { Trans } from 'lib/translation';
import Typography from 'commonComponents/typography';
import AchAuthorizationStyles from './AchAuthorizationStyles';
import achAuthorizationPageDetails from './AchAuthorization.utils';

function AchAuthorization() {
  const classes = AchAuthorizationStyles();

  return (
    <EVPaper className={classes.achAuthorizationPaper}>
      <EVGrid container className={classes.detailsContainer}>
        {achAuthorizationPageDetails.map((section) => (
          <EVGrid key={section.title}>
            <Typography variant="h1-400" fontColor="ocean-600">
              <Trans i18nKey={section.title} />
            </Typography>
            <Typography variant="body-400" fontColor="charcoal-900">
              <Trans i18nKey={section.info} />
            </Typography>
          </EVGrid>
        ))}
      </EVGrid>
    </EVPaper>
  );
}

export default AchAuthorization;
